<!-- Navbar -->
<div *ngIf="mode" style="width: 100%; text-align: center;background-color: #dc3545;"><h5 style="color: white;">{{mode}}</h5></div>  
<nav class="main-header navbar navbar-expand navbar-white navbar-light">
  <app-navbar-left-links></app-navbar-left-links>
  <app-navbar-search-form></app-navbar-search-form>
  <app-navbar-right-links class="ml-auto"></app-navbar-right-links>
</nav>
<!-- /.navbar -->